import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";

const PopupDownloadSuccessful = ({ open, close ,children ,selectTemplate }) => {
  return (
    <GenericPopup opacity open={open} className="artwork-options__download-template-container w-[30em] ">
      <p className="artwork-options__download-template_header-text">
        Generate template
      </p>
      <p className="artwork-options__download-template_header-step-text mb-0">
        The template has been successfully downloaded
      </p>
      <div className={`artwork-options__download-template-templates__story h-10 ${selectTemplate ==="story" ? "scale-[0.16]" : "scale-[0.22]" }`}>
        {children}
      </div>
      <ContinueButton
        className={`active border-[3px] ${selectTemplate ==="story" ? "mt-[300px]" : "mt-[290px]" } `}
        onClick={() => {
          close();
        }}
      >
          Close
      </ContinueButton>
    </GenericPopup>
  );
};

export default PopupDownloadSuccessful;
